

























import { Component, Vue, Prop } from 'vue-property-decorator'
import { ManualAdjustUserFrozenPoints } from '@/api'
import { ElForm } from 'element-ui/types/form'

@Component
export default class ManualAdjustFrozenPointsDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  private show = false
  private saving = false
  private form: any = {
    userId: undefined as number | undefined,
    mobilePhone: '',
    frozenMungBeanQty: undefined as number | string | undefined,
    adjustType: 1,
    qty: '',
    note: '',
  }

  private rules = {
    adjustType: [{ required: true, message: '请选择调整类型', trigger: 'change' }],
    qty: [
      { required: true, message: '请输入变动数量', trigger: 'blur' },
      {
        validator: (_: any, v: string, cb: (e?: Error) => void) => {
          const n = parseFloat(String(v).trim())
          if (Number.isNaN(n) || n <= 0) {
            cb(new Error('变动数量须为大于0的数字'))
          } else {
            cb()
          }
        },
        trigger: 'blur',
      },
    ],
  }

  get displayBalance() {
    const v = this.form.frozenMungBeanQty
    if (v === undefined || v === null || v === '') {
      return '-'
    }
    return String(v)
  }

  public open(data: any) {
    this.show = true
    this.form.userId = data.id
    this.form.mobilePhone = data.mobilePhone || ''
    this.form.frozenMungBeanQty = data.frozenMungBeanQty
    this.form.adjustType = 1
    this.form.qty = ''
    this.form.note = ''
    this.$nextTick(() => {
      const f = this.$refs.formRef as ElForm
      f && f.clearValidate()
    })
  }

  private close() {
    this.show = false
  }

  private async save() {
    const f = this.$refs.formRef as ElForm
    f.validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      this.saving = true
      try {
        await ManualAdjustUserFrozenPoints({
          userId: this.form.userId,
          qty: parseFloat(String(this.form.qty).trim()),
          adjustType: this.form.adjustType,
          note: this.form.note || undefined,
        })
        this.$message.success('保存成功')
        this.close()
        this.$emit('success')
      } finally {
        this.saving = false
      }
    })
  }
}
